import cx from 'classnames';
import type { ReactNode } from 'react';
import type { InputFormState } from '../../utils/form';
import { Typography } from '../Typography';
import styles from './styles.module.css';

export interface InputFeedbackProps {
  state?: InputFormState;
  children: NonNullable<ReactNode>;
}

/**
 * Renders an helper sentence below an input.
 *
 * @deprecated use InputFeedback from kitt-universal instead
 */
export function InputFeedback({ state, children }: InputFeedbackProps): ReactNode {
  return (
    <Typography.div
      base="body-small"
      className={cx(styles.InputFeedback, {
        [styles.Valid]: state === 'valid',
        [styles.Invalid]: state === 'invalid',
      })}
    >
      {children}
    </Typography.div>
  );
}
